// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__1lRXj","expandIconWrapper":"CustomNode_expandIconWrapper__3MxGa","isOpen":"CustomNode_isOpen__3D1FM","labelGridItem":"CustomNode_labelGridItem__4Kwnb"};